import React, { useState, useEffect } from 'react';
import Header from './../../components/user/common/Header';
import PageTitle from './../../components/user/common/PageTitle';
import Sidebar from './../../components/user/common/Sidebar';
import Footer from './../../components/common/Footer';
import ProductCard from './../../components/common/ProductCard';
import { NotFound } from './../../components/common/NotFound';
import SpinnerLoader from './../../components/common/SpinnerLoader';
import axios from 'axios';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setProducts, setReqBody, setTotalProducts, setMaxPrice } from './../../store/reducers/product-reducer';
import readUrl from './../../helpers/read-product-listing-url';
import { Helmet } from 'react-helmet';
import GoToTop from './../../helpers/GoToTop';
import arrow_back from '../../assets/icons/arrow-back.svg'

const ProductListing = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const category = queryParams.get("cat");
    const searchQuery = queryParams.get("searchText");
    const subCat = queryParams.get("subcat");
    const reqBodyFromStore = useSelector(state => state.product.reqBody);
    // const { loading } = useSelector(state => state.global);

    const { totalProducts } = useSelector(state => state.product);
    const [reqBody, setReqBodyState] = useState(JSON.parse(JSON.stringify(reqBodyFromStore)));
    const [products, setProductsState] = useState([]);
    const [loading, setLoading] = useState(true);
    const [priceRange, setPriceRange] = useState();
    const [selectedCategories, setSelectedCategories] = useState(
        () => (category ? [category] : [])
    );
    const [selectedSubCategories, setSelectedSubCategories] = useState(
        () => (subCat ? [subCat] : [])
    );
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [categories, setCategories] = useState('');
    const [sideBarToggle, setSideBarToggle] = useState(false);
    const [super_rewards, setRewards] = useState(false);
    const [brands, setBrands] = useState(0);
    
    // ADDED: Simple sorting state (default to ranking)
    const [sortBy, setSortBy] = useState('ranking');

    useEffect(() => {
        try {
            const reward = location.state?.rewards || false;
            setRewards(reward);
        } catch (error) {
            setRewards(false);
        }
    }, [location]);

    useEffect(() => {
        if (!category) {
            setSelectedCategories((prev) => (prev.length === 0 ? prev : []));
        } else {
            setSelectedCategories((prev) =>
                prev.length === 1 && prev[0] === category ? prev : [category]
            );
        }
    }, [category]);

    useEffect(() => {
        if (!subCat) {
            setSelectedSubCategories((prev) => (prev.length === 0 ? prev : []));
        } else {
            setSelectedSubCategories((prev) =>
                prev.length === 1 && prev[0] === subCat ? prev : [subCat]
            );
        }
    }, [subCat]);

    useEffect(() => {
        axios.get("front/allProductCategory")
            .then((response) => {
                if (response.data.status) {
                    setCategories(response.data.data);
                } else {
                    console.log("Error")
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .get("front/allProductBrands")
            .then((response) => {
                if (response.data.status) {
                    setBrands(response.data.data);
                } else {
                    console.log(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let reqBodyUpdated = { ...reqBody };
        reqBodyUpdated = readUrl(dispatch, reqBodyUpdated, window.location, setReqBody, 'product-listing');
        setReqBodyState(reqBodyUpdated);
        // getProducts('didMount');
    }, []);

    useEffect(() => {
        getProducts()
    }, [priceRange, selectedBrands, selectedCategories, selectedSubCategories, super_rewards, searchQuery, sortBy]) // ADDED: sortBy to dependencies

    const handlePriceRangeChange = (range) => {
        setPriceRange(range);
    };

    const handleCategoryChange = (categories) => {
        setSelectedCategories(categories);
    };

    const handleSubCategoryChange = (categories) => {
        if (subCat) {
            console.log("subCat test", subCat)
        }
        setSelectedSubCategories(categories);
    };

    const handleBrandChange = (brands) => {
        setSelectedBrands(brands);
    };

    // ADDED: Simple sort handler
    const handleSortChange = (newSortBy) => {
        setSortBy(newSortBy);
    };

    const getProducts = async () => {
        setLoading(true);

        try {
            const isPriceFilterActive =
                Array.isArray(priceRange) &&
                priceRange.length === 2 &&
                Number.isFinite(priceRange[0]) &&
                Number.isFinite(priceRange[1]);

            const hasFilters =
                isPriceFilterActive ||
                selectedCategories.length > 0 ||
                selectedSubCategories.length > 0 ||
                selectedBrands.length > 0 ||
                Boolean(searchQuery) ||
                super_rewards;

            if (sortBy === 'ranking' && !hasFilters) {
                // ADDED: Use the new ranking endpoint when no filters and sorting by ranking
                const response = await axios.get('front/products/ranked?limit=50');
                
                if (response.data.success) {
                    const productsData = response.data.data.map(product => ({
                        id: product._id,
                        image: product.featuredImage,
                        name: product.name,
                        isService: product.isService || false,
                        price: product.price,
                        avgRating: product.avgRating || 0,
                        quantity: product.quantity,
                        cryptoPrices: product.cryptoPrices || [],
                        super_rewards: product.super_rewards || false,
                        color_size: product.color_size || [],
                        // ADDED: Include ranking data
                        ranking: product.ranking,
                        badge: product.badge
                    }));

                    setProductsState(productsData);
                } else {
                    setProductsState([]);
                }
            } else {
                const reqBodyUpdated = {
                    priceRange: isPriceFilterActive ? priceRange : undefined,
                    selectedCategories,
                    selectedSubCategories,
                    selectedBrands,
                    searchQuery,
                    super_rewards,
                    sortBy,
                };

                const response = await axios.post('front/products/listing', reqBodyUpdated);

                if (response.data.status) {
                    const res = response.data.data;
                    const productsData = res.map((product) => {
                        let avgRating = 0;
                        if (product.reviews?.length > 0) {
                            const totalRatings = product.reviews.reduce((sum, review) => sum + review.rating, 0);
                            avgRating = totalRatings / product.reviews.length;
                            avgRating = avgRating % 1 >= 0.8 ? Math.ceil(avgRating) : avgRating.toFixed(1);
                        }

                        return {
                            id: product.id,
                            image: product.featuredImage,
                            name: product.name,
                            isService: product.isService,
                            price: product.price,
                            avgRating: avgRating,
                            quantity: product.quantity,
                            cryptoPrices: product.cryptoPrices,
                            super_rewards: product.super_rewards,
                            color_size: product.color_size,
                            // ADDED: Include ranking data if available
                            ranking: product.ranking,
                            badge: product.badge
                        };
                    });

                    setProductsState(productsData);
                } else {
                    setProductsState([]);
                }
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setLoading(false); // Stop loading after request completes
        }
    };

    return (
        <React.Fragment>
            <Helmet><title>{"Products - Pay Earth"}</title></Helmet>
            {loading === true ? <SpinnerLoader /> : ''}
            <Header
                pageName="product-listing"
                reqBody={reqBody}
            // sendProductsData={handleProductData}
            />
            <PageTitle title={"Products"} />
            <section className="inr_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <div className="pt-2 d-flex flex-wrap gap-2">
                                <span className="text-uppercase fw-bold">
                                CATEGORIES: {categories.length || 0}
                                </span>
                                <span className="text-uppercase fw-bold">
                                BRANDS: {brands.length || 0}
                                </span>
                                <span className="text-uppercase fw-bold">
                                PRODUCTS: {products.length || 0}
                                </span>
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <div className="sort-dropdown">
                                <label htmlFor="sortSelect" className="form-label mb-0 me-2">
                                    Sort by:
                                </label>
                                <select
                                    id="sortSelect"
                                    className="form-select form-select-sm"
                                    value={sortBy}
                                    onChange={(e) => handleSortChange(e.target.value)}
                                    style={{ minWidth: "150px" }}
                                >
                                    <option value="ranking">Best Ranked</option>
                                    <option value="avgRating">Highest Rated</option>
                                    <option value="newest">Newest First</option>
                                    <option value="price_low">Price: Low to High</option>
                                    <option value="price_high">Price: High to Low</option>
                                </select>
                                </div>

                                <button
                                type="button"
                                className="btn custum_back_btn btn_yellow d-flex align-items-center show-desktop"
                                onClick={() => window.history.back()}
                                >
                                <img src={arrow_back} alt="back" className="me-2" />
                                Back
                                </button>
                            </div>
                        </div>

                        <div className="col-md-3 mt-3" style={{ overflowY: 'auto', maxHeight: '120vh', border: '1px solid #ddd', scrollbarWidth: 'thin', }}>
                            <div className='mob-show'>
                                <div className="filter_back_btn">
                                    <button className="filter-mob-catShow px-2" type="button" aria-controls="navbarExampleOnHover" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setSideBarToggle(prevState => !prevState)}><span className="fa fa-bars"></span> Filter</button>

                                    <button
                                        type="button"
                                        className="btn custum_back_btn btn_yellow d-flex align-items-center"
                                        onClick={() => window.history.back()}
                                    >
                                        <img src={arrow_back} alt="back" className="me-2" />
                                        Back
                                    </button>
                                </div>
                            </div>
                            <Sidebar pageName="product-listing"
                                sideBarToggle={sideBarToggle}
                                categories={categories}
                                onPriceRangeChange={handlePriceRangeChange}
                                onCategoryChange={handleCategoryChange}
                                onSubCategoryChange={handleSubCategoryChange}
                                onBrandChange={handleBrandChange}
                            />
                        </div>
                        <div
                            className="col-md-9 mt-3"
                            style={{
                                overflowY: "auto",
                                maxHeight: "120vh",
                                border: "1px solid #ddd",
                                scrollbarWidth: "thin",
                            }}
                            >
                            <div className="row">
                                <div className="col-sm-12">
                                {super_rewards === true ? (
                                    <Link
                                    to={{
                                        pathname: "/product-listing",
                                        state: {
                                        rewards: false,
                                        },
                                    }}
                                    >
                                    <h3>All Products</h3>
                                    </Link>
                                ) : (
                                    ""
                                )}

                                {products.length === 0 ? (
                                    <NotFound msg="Product not found." />
                                ) : (
                                    ""
                                )}

                                {/* Make cards flex & center on mobile */}
                                <div className="cards_wrapper d-flex flex-wrap justify-content-center">
                                    {products.map((product, index) => {
                                    const getCustomBadge = (index, sortBy) => {
                                        if (sortBy === "ranking") {
                                        if (index === 0) return "Best Seller";
                                        if (index === 1) return "Popular Choice";
                                        if (index === 2) return "Fan Favourite";
                                        }
                                        return null;
                                    };

                                    const customBadge = getCustomBadge(index, sortBy);

                                    return (
                                        <div
                                        key={index}
                                        className="product-wrapper position-relative"
                                        >
                                        {customBadge && (
                                            <div className={`product-badge custom-badge-${index + 1}`}>
                                            {customBadge}
                                            </div>
                                        )}

                                        <ProductCard
                                            data={product}
                                        />
                                        </div>
                                    );
                                    })}
                                </div>
                                </div>

                                {products.length !== 0 && products.length < totalProducts && (
                                <div className="col-md-12 more_pord_load_btn text-center">
                                    <button
                                    type="button"
                                    onClick={() => getProducts("viewMore")}
                                    className="view_more"
                                    >
                                    View More
                                    </button>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ADDED: Simple CSS for badges */}
            <style jsx>{`
                .product-wrapper {
                    position: relative;
                }
    
                .product-badge {
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    color: white;
                    z-index: 9;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
                }
                
                /* Custom badges for top 3 products */
                .custom-badge-1 {
                    background: linear-gradient(45deg, #e74c3c, #c0392b);
                    border: 2px solid #fff;
                }
                
                .custom-badge-2 {
                    background: linear-gradient(45deg, #f39c12, #e67e22);
                    border: 2px solid #fff;
                }
                
                .custom-badge-3 {
                    background: linear-gradient(45deg, #27ae60, #229954);
                    border: 2px solid #fff;
                }
                
                .sort-dropdown {
                    display: flex;
                    align-items: center;
                }
                
                @media (max-width: 768px) {
                    .product-badge {
                        font-size: 8px;
                        padding: 2px 6px;
                    }
                    
                    .ranking-badge {
                        width: 20px;
                        height: 20px;
                        font-size: 9px;
                    }
                }
            `}</style>

            <Footer />
            <GoToTop />
        </React.Fragment>
    );
}

export default ProductListing;